import React from 'react'

const EmailCaptureSubtitle = ({data, category}) => {

	let copy;
	data = data?.allContentfulSiteGlobalData?.edges[0]?.node;

	switch (category) {
		case 'Business':
			copy = data?.v2CommunityBusinessCopy?.v2CommunityBusinessCopy
			break;
		case 'Contributor':
			copy = data?.v2CommunityContributorsCopy?.v2CommunityContributorsCopy
			break;
		case 'Collaborator':
			copy = data?.v2CommunityCollaboratorsCopy?.v2CommunityCollaboratorsCopy
			break;
		case 'Resources':
			copy = "Whether you’re a marketing pro or just starting out, we’re here to help you reach your goals."
			break;
		default:
			copy = null;
	}


	return (
		<p>
			{copy}

			<style jsx>{`
				p {
					font-size: 20px;
					line-height: 1.4;
					width: 500px;
					text-align: center;
				}

				@media (max-width: 769px), (pointer: coarse) {
					p {
						width: 100%;
					}
				}
			`}</style>
		</p>
	)
}

export default EmailCaptureSubtitle
